import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import { Grid } from '../../components/GridSystem';
import PageHeading from '../../components/PageHeading';
import ExpertiseBlock from './ExpertiseBlock';
import StoryBlock from './StoryBlock';
import PeopleBlock from './PeopleBlock';

class About extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>About - Hubton Indonesia</title>
                </Helmet>

                <PageHeading title="About" />

                <div className="main-section block-section pt-0">
                    <Grid>

                        <ExpertiseBlock />
                        <StoryBlock />
                        <PeopleBlock />

                    </Grid>
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/containers/About/index.js